import RSSParser from "rss-parser";
import AuthService from '../../services/AuthService';
import LocalizationService from '../../services/LocalizationService';
import ProxyService from "../../services/ProxyService";

//init functions and params
import CoreInitService from '../../services/CoreInitService';
const sUIApi2 = CoreInitService.sUIApi2, sUIApi2Enforcer = CoreInitService.sUIApi2Enforcer, debounce = CoreInitService.debounce, keyCodes = CoreInitService.keyCodes, initialState = CoreInitService.initialState;
let toastDebounce = CoreInitService.toastDebounce, thousandDelimeter = CoreInitService.thousandDelimeter, accountMask = CoreInitService.accountMask;

const proxyConfig = require('../../config/config');

//--- memory cache identify
const mcache = require('memory-cache');
import {isMobile} from 'mobile-device-detect'
import createMutationsSharer from "vuex-shared-mutations"


const merge = (...args) => {
    const target = {};  // Merge the object into the target object
    const merger = (obj) => {
        for (let prop in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if (obj.hasOwnProperty(prop)) {
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]'){
                    // If we're doing a deep merge
                    // and the property is an object
                    target[prop] = merge(target[prop], obj[prop]);
                } else {
                    // Otherwise, do a regular merge
                    target[prop] = obj[prop];
                }
            }
        }
    };   //Loop through each object and conduct a merge
    for (let i = 0; i < args.length; i++) {
        merger(args[i]);
    }     return target;
};

export default class MLMSoftUICore {
    #store;

    /**
     *
     * @param enforcer
     */
    constructor(enforcer) {
        if (enforcer !== sUIApi2Enforcer)
            throw "Instantiation failed: use MLMSoftUICore.getInstance() instead of new.";
        // код конструктора
        this.#store = new window.Vuex.Store({
            plugins: [createMutationsSharer({predicate: ["setFeedProductCount", "setLocale", "setEmptyPerson", "setLazyLoadItem",
                    "setRefreshTokenAction", "setRefreshApi3TokenAction", "setIsLoggedInApi3", "setTokensToStorage", "setApi3TokensToStorage", "localeFromStorage",
                    "getTokensFromStorage","getApi3TokensFromStorage" ,"setIsLoggedIn", "resetState", "setPaymentStackFromStorage", "deletePaymentStack", "addPaymentToStack"]})], //,"setAccountTemplate","setAccountInfo","setMapAccountInfo",
            //  "setLoadingAccountInfo","deleteLoadingAccountInfo"
            state: {
                initialState          : initialState,
                ...initialState(),
                feedUrl               : '',
                feedGroupNumber       : 0,
                refreshToken          : null,
                refreshTokenApi3      : null,
                refreshTokenAction    : null,
                refreshTokenActionApi3: null,
                accessToken           : null,
                accessTokenApi3       : null,
                singleAccessToken     : null,
                singleRefreshToken    : null,
                emptyPerson           : '',
                fontFamilyRe          : null,
                lazyLoadItem          : '',
                paymentStack          : [],
                isMobile              : isMobile,
                emptyPersonFemale     : '',
                emptyPersonMale       : '',
                loginBackImg          : '',
                avatarAddNew          : '',
                avatarLock            : '',
                isLoggedIn            : true,
                mapAccountInfo        : new Map(),                //key such as (m/p/s/w).(PW/GW/Rank/...)
                accountTemplate       : new Map(),
                locale                : 'en-US', //locale (en-US/en-GB/ru-RU/...)
                toastFunction         : function () {},
                headerCartCoords      : null,
                currentAccount        : null,
                currentProfile        : null,
                isOnline              : false,
                locProps              : [],
                pureVal               : (value) => value.replace(/^.\./g,''),
                parseTemplateValue    : async function(position, profile, template, ctx) {
                    let tAlias       = template.match(/^[\\.\w]*=/)
                    let tValue       = template.replace(/^[\\.\w]*=/, '')
                    let sponsorName  = ''

                    if (!tAlias[0]) {
                        return 'NOT FOUND'
                    }
    
                    tValue                = tValue.replace(/{.\./g,'{')
                    let templateArrProps  = tValue.match(/({\w*})*/g)
                    tAlias                = ctx.state.pureVal(tAlias[0]).slice(0,-1) // "t.sponsor_info=" // => // "sponsor_info"
                    let foundForTemplates = []
    
                    if (tAlias === 'sponsor_info') {
                        await ctx.dispatch('requestApi3', {
                            path: `account/${this.sponsorId || 4}/profile`,
                            method: 'get'
                        }).then((response) => {
                            let sponsorProfile = response.data.payload 
    
                            let fName = sponsorProfile.find((p) => p.alias === 'firstname');
                            let lName = sponsorProfile.find((p) => p.alias === 'lastname');
    
                            if (fName) {
                                sponsorName = fName.value.presentable
                            }
                            if (lName) {
                                sponsorName = sponsorName + ' ' + lName.value.presentable
                            }
                        }).catch((e) => {
                            console.log(e)
                        })
                    }
    
                    templateArrProps.forEach((tProp) => {
                        if (tProp) {

                            if (position?.length) {
                                position[0].properties.forEach((p) => {
                                    if (tProp.replace(/[}{]/g,'') == ctx.state.pureVal(p.alias)) {
                                        foundForTemplates.push([tProp, p]);
                                    }
                                });
                            }

                            if (profile?.length) {
                                profile.forEach((p) => {
                                    if (tProp.replace(/[}{]/g,'') === 'referral_code' && ctx.state.pureVal(p.alias) === 'invite_code') {
                                        foundForTemplates.push([tProp, p]);
                                    } else {
        
                                        if (tProp.replace(/[}{]/g,'') == ctx.state.pureVal(p.alias)) {
                                            foundForTemplates.push([tProp, p]);
                                        }
                                    }
                                });
                            }
    
                            if (tProp.replace(/[}{]/g,'') === 'parent_name') {
                                foundForTemplates.push(['parent_name', {
                                    title: 'parent_name',
                                    value: {
                                        presentable : sponsorName,
                                        raw         : sponsorName
                                    }
                                }]);
                            }
    
                            if (tProp.replace(/[}{]/g,'') === 'parent_account_id') {
                                foundForTemplates.push(['parent_account_id', {
                                    title: 'parent_account_id',
                                    value: {
                                        presentable : this.sponsorId || 4,
                                        raw         : this.sponsorId || 4
                                    }
                                }]);
                            }
                        }
                    })
    
                    let newTValue = tValue
    
                    foundForTemplates.forEach(found => {
                        newTValue = newTValue.replace(new RegExp(found[0],'g'), found[1].value.presentable)
                    });
    
                    return new Promise((resolve) => resolve(newTValue))
                },
            },
            getters: {
                tokensSSO: state => {
                    return {accessToken: state.accessToken, refreshToken: state.refreshToken}
                },
                getCart: state => {
                    return state.cart
                }
            },
            mutations: {
                //pay in mutations
                setPaymentStackFromStorage(state) {
                    let pmts = localStorage.getItem('payments');
                    if (!pmts)
                        return;
                    try {
                        pmts = JSON.parse(pmts);
                        if (Array.isArray(pmts)){
                            if (pmts.length>0)
                                for (let i = pmts.length-1; i > -1; i--){
                                    let ii = new Date() - new Date(pmts[0].expire);
                                    if (ii < 0 || ii > 3600000)
                                        pmts.splice(i,1);
                                }
                            if (pmts.length>0){
                                state.paymentStack = pmts;
                                localStorage.setItem('payments',JSON.stringify(state.paymentStack));
                            }
                            else{
                                localStorage.removeItem('payments');
                                state.paymentStack = [];
                            }
                        }
                        else {
                            localStorage.removeItem('payments');
                            state.paymentStack = [];
                        }
                    }
                    catch (e) {
                        state.paymentStack = [];
                    }
                },
                deletePaymentStack(state) {
                    localStorage.removeItem('payments');
                    state.paymentStack = [];
                },
                addPaymentToStack(state, newPayment) {
                    newPayment.expire = new Date();
                    state.paymentStack.push(newPayment);
                    localStorage.setItem('payments',JSON.stringify(state.paymentStack));
                },
                removePaymentFromStack(state, index) {
                    if (state.paymentStack.length > index)
                    {
                        state.paymentStack.splice(index,1);
                        localStorage.setItem('payments',JSON.stringify(state.paymentStack));
                    }
                },
                //state reset mutation on logout
                resetState: (state) => {
                    Object.keys(state.initialState()).forEach(k => {
                        state[k] = state.initialState()[k];
                    });
                    mcache.clear();
                },
                setAccountId(state, newAccountId) {
                    state.accountId = newAccountId
                },
                setFontFamilyRe(state, newFontFamily) {
                    state.fontFamilyRe = newFontFamily;
                },
                setEmptyPerson(state, newEmptyPerson) {
                    state.emptyPerson = newEmptyPerson;
                },
                setLazyLoadItem(state, newLazyLoadItem) {
                    state.lazyLoadItem = newLazyLoadItem;
                },
                setEmptyPersonMale(state, newEmptyPersonMale) {
                    state.emptyPersonMale = newEmptyPersonMale;
                },
                setEmptyPersonFemale(state, newEmptyPersonFemale) {
                    state.emptyPersonFemale = newEmptyPersonFemale;
                },
                setLoginBackImg(state, newLoginBackImg) {
                    state.loginBackImg = newLoginBackImg;
                },
                setAvatarAddNew(state, newAvatarAddNew) {
                    state.avatarAddNew = newAvatarAddNew;
                },
                setAvatarLock(state, newAvatarLock) {
                    state.avatarLock = newAvatarLock;
                },
                setRefreshTokenAction(state, newAct) {
                    state.refreshTokenAction = newAct;
                },
                setRefreshApi3TokenAction(state, newAct) {
                    state.refreshTokenActionApi3 = newAct;
                },
                setAccountTemplate(state, newArr) {
                    state.gravTemplates   = newArr
                    state.accountTemplate = new Map(state.accountTemplate);
                    state.mapAccountInfo  = new Map(state.mapAccountInfo);
                    newArr.forEach(value => {
                        if (value.length > 4) {
                            let key_t = value.indexOf('='), value_t, title_t = value.indexOf('{');
                            const ket_t_ = key_t;
                            (value.length > (title_t + 2)) && (value_t = value.slice(title_t).trim()) && (key_t = value.slice(0, key_t).trim());
                            if (title_t > ket_t_) {
                                title_t = value.slice(ket_t_ + 1, title_t).trim()
                            } else
                                title_t = "";
                            if (key_t && value_t.length > 2) {
                                value_t = value_t.slice(1, -1);
                                state.accountTemplate.set(key_t, {obj_val: value_t});
                                state.mapAccountInfo.set(key_t, title_t);

                                let obj_set = new Set();
                                let v = value_t;
                                let t = true, i_search = 0;
                                while (t) {
                                    let fi = v.indexOf('{', i_search), li = v.indexOf('}', i_search);
                                    if (fi >= 0 && li && fi < li) {
                                        i_search = li + 1;
                                        let new_val = v.slice(fi + 1, li);
                                        if (new_val) {
                                            obj_set.add(new_val);
                                        }
                                    } else t = false;
                                }
                                let t_ = state.accountTemplate.get(key_t);
                                t_.obj_set = obj_set;
                                t_.obj_func = (accountIndex) => {
                                    let v = state.accountTemplate.get(key_t);
                                    let vv = v.obj_val;
                                    if (v.obj_set && v.obj_val)
                                        v.obj_set.forEach(item => {
                                            if (state.accountInfo.has(accountIndex + '.' + item) && state.accountInfo.get(accountIndex + '.' + item).obj_val && state.accountInfo.get(accountIndex + '.' + item).obj_val['presentableValue']) {
                                                let re = new RegExp('{' + item + '}', 'g');
                                                vv = vv.replace(re, state.accountInfo.get(accountIndex + '.' + item).obj_val['presentableValue']);
                                            }
                                            else {
                                                let re = new RegExp('{' + item + '}', 'g');
                                                vv = vv.replace(re, 'empty');
                                            }
                                        });
                                    return vv;
                                };
                            }
                        }
                    });
                },
                setAccountInfo(state, newMap) {
                    state.accountInfo = new Map(state.accountInfo);
                    newMap.forEach((valueAll) => {
                        let key = valueAll[0], value = valueAll[1];
                        if (state.accountInfo.has(key))
                            state.accountInfo.get(key).obj_val = typeof value === 'object' ? value : {
                                value: value,
                                presentableValue: /s.account_id$/.test(key) ? MLMSoftUICore.formatAccountId(value.toString() || '0') : value
                            };
                        else
                            state.accountInfo.set(key, {
                                obj_val: typeof value === 'object' ? value : {
                                    value: value,
                                    presentableValue: /s.account_id$/.test(key) ? MLMSoftUICore.formatAccountId(value.toString() || '0') : value
                                }
                            });
                        mcache.put(key, value, proxyConfig.cacheTime * 1000);
                    });
                },
                setMapAccountInfo(state, newMap) {
                    state.mapAccountInfo = new Map(state.mapAccountInfo);
                    newMap.forEach((valueAll) => {
                        let key = valueAll[0], value = valueAll[1];
                        state.mapAccountInfo.set(key, value)
                    });
                },
                setLoadingAccountInfo(state, {newSet, newPromise}) {
                    state.loadingAccountInfo = new Map(state.loadingAccountInfo);
                    newSet.forEach(value => state.loadingAccountInfo.set(value, newPromise));
                },
                setLoadingAccountId(state, newPromise) {
                    state.loadingAccountId = newPromise;
                },
                deleteLoadingAccountInfo(state, newSet) {
                    state.loadingAccountInfo = new Map(state.loadingAccountInfo);
                    newSet.forEach(value => state.loadingAccountInfo.delete(value));
                },
                deleteLoadingAccountId(state) {
                    state.loadingAccountId = null;
                },
                setTokensToStorage(state, {accessToken, refreshToken}) {
                    state.accessToken = accessToken;
                    state.refreshToken = refreshToken;
                    accessToken ? localStorage.setItem('user-token', state.accessToken) : localStorage.removeItem('user-token');
                    refreshToken ? localStorage.setItem('user-refresh-token', state.refreshToken) : localStorage.removeItem('user-refresh-token');
                },
                setApi3TokensToStorage(state, {accessToken, refreshToken}) {
                    state.accessTokenApi3 = accessToken;
                    state.refreshTokenApi3 = refreshToken;
                    accessToken ? localStorage.setItem('accessTokenApi3', accessToken) : localStorage.removeItem('accessTokenApi3');
                    refreshToken ? localStorage.setItem('refreshTokenApi3', refreshToken) : localStorage.removeItem('refreshTokenApi3');
                },
                setSingleTokensToStorage(state, {singleAccessToken, singleRefreshToken}) {
                    state.singleAccessToken = singleAccessToken;
                    state.singleRefreshToken = singleRefreshToken;
                    singleAccessToken ? localStorage.setItem('user-single-a-token', state.singleAccessToken) : localStorage.removeItem('user-single-a-token');
                    singleRefreshToken ? localStorage.setItem('user-single-r-token', state.singleRefreshToken) : localStorage.removeItem('user-single-r-token');
                },
                localeFromStorage(state, {defaultLocale, freezeLocale}) {
                    if (freezeLocale) {
                        state.freezeLocale = true;
                        state.locale = defaultLocale;
                    } else {
                        state.freezeLocale = false;
                        let loc = localStorage.getItem('locale');
                        if (loc)
                            state.locale = loc;
                        else if (!loc) {
                            localStorage.setItem('locale', defaultLocale);
                            state.locale = defaultLocale;
                        }
                    }
                },
                getTokensFromStorage(state) {
                    const t = localStorage.getItem('user-token');
                    const rt = localStorage.getItem('user-refresh-token');
                    if (t && rt) {
                        state.accessToken = t;
                        state.refreshToken = rt;
                    } else {
                        if (state.isLoggedIn){
                            state.isLoggedIn = false;
                            Object.keys(state.initialState()).forEach(k => {
                                state[k] = state.initialState()[k];
                            });
                            mcache.clear();
                        }
                        localStorage.removeItem('user-token');
                        localStorage.removeItem('user-refresh-token');
                        state.accessToken = null;
                        state.refreshToken = null;
                    }
                },
                getApi3TokensFromStorage(state) {
                    const t = localStorage.getItem('accessTokenApi3');
                    const rt = localStorage.getItem('refreshTokenApi3');
                    if (t && rt) {
                        state.accessTokenApi3 = t;
                        state.refreshTokenApi3 = rt;
                    } else {
                        if (state.isLoggedInApi3){
                            state.isLoggedInApi3 = false;
                            Object.keys(state.initialState()).forEach(k => {
                                state[k] = state.initialState()[k];
                            });
                            mcache.clear();
                        }
                    }
                },
                getSingleTokensFromStorage(state) {
                    const st = localStorage.getItem('user-single-a-token');
                    const srt = localStorage.getItem('user-single-r-token');
                    if (st && srt) {
                        state.singleAccessToken = st;
                        state.singleRefreshToken = srt;
                    } else {
                        localStorage.removeItem('user-single-a-token');
                        localStorage.removeItem('user-single-r-token');
                        state.singleAccessToken = null;
                        state.singleRefreshToken = null;
                    }
                },
                setLocale(state, locale) {
                    if (state.freezeLocale)
                        return 1;
                    mcache.clear();
                    state.mapAccountInfo = new Map();
                    state.locale = locale;
                    localStorage.setItem('locale', locale);
                    document.dispatchEvent(new CustomEvent('Locale_changed', {'detail': locale}));
                },
                setIsLoggedIn(state, isLoggedIn) {
                    state.isLoggedIn = isLoggedIn;
                },
                setIsLoggedInApi3(state, isLoggedIn) {
                    state.isLoggedInApi3 = isLoggedIn;
                },
                setToastFunction(state, fnc) {
                    state.toastFunction = fnc;
                    toastDebounce = debounce(fnc, 1000);
                },
                //feed
                setFeedUrl(state, newFeedUrl) {
                    state.feedUrl = newFeedUrl;
                },
                updateCartFromStorage(state) {
                    const cartArr = localStorage.getItem('cart');
                    const cartInner = JSON.parse(cartArr);
                    try {
                        cartInner.map(item => {
                            state.feed.feedInner.items.map(sItem => {
                                if(item['g:id'] === sItem['g:id']) {
                                    sItem.count = item.count
                                }
                            })
                        })
                    } catch (e) {
                        console.log(e)
                    }
                },
                updateCart(state) {
                    let newCart = [];
                    try {
                        let tempArr = []
                        let tempArrIds = []
                        state.feed.feedInner.items.map(sItem => {
                            if(!tempArrIds.includes(sItem['g:id'])) {
                                tempArrIds.push(sItem['g:id'])
                                tempArr.push(sItem)
                                if(sItem['count'] > 0) {
                                    newCart.push(sItem);
                                }
                            }
                        })
                    } catch (e) {
                        console.log(e)
                    }
                    state.cart = newCart;
                    localStorage.setItem('cart', JSON.stringify(newCart));

                    let miniCart = document.getElementsByTagName('v-mini-cart')[0];
                    if(miniCart)
                        miniCart.setAttribute('counter', miniCart.getAttribute('counter') + 1)
                },
                emptyCart(state, payload) {
                    state.cart = payload
                },
                saveCart(state, newCart) {
                    let miniCart = document.getElementsByTagName('v-mini-cart')[0];
                    state.cart = newCart;
                    if(miniCart)
                        miniCart.setAttribute('counter', miniCart.getAttribute('counter') + 1)

                },
                setFeedProductCount(state, product){

                    state.feed.feedInner.items.map(a=> {
                        if(a['g:id'] == product['g:id']) {
                            console.log('product', product)
                            a.count = product.count
                        }
                    });
                    // if (prodFind)
                    //     prodFind.count=product.count;

                    localStorage.setItem('feed', JSON.stringify(state.feed));
                },
                setFeedGroupNumber(state,newFeedGroupNumber){
                    state.feedGroupNumber = newFeedGroupNumber;
                },
                deleteFeedUrl(state) {
                    localStorage.removeItem('feedUrl');
                    state.feedUrl = '';
                },
                setFeed(state, newFeed) {
                    state.feed = newFeed;
                    state.feed.locale = state.locale;
                    localStorage.setItem('feed', JSON.stringify(newFeed));
                },
                deleteFeed(state) {
                    state.feed.feedInner = null;
                    localStorage.removeItem('feed');
                },
                setHeaderCartCoords(state, coords) {
                    state.headerCartCoords = coords;
                },
                setOnlineStatus(state, status) {
                    state.isOnline = status;
                },
                setPropsLocalization(state, localizations) {
                    state.locProps = localizations;
                },
                setCurrentAccount(state, currentAccount) {
                    state.currentAccount = currentAccount;
                },
                setCurrentProfile(state, currentProfile) {
                    state.currentProfile = currentProfile;
                }
            },
            actions: {
                async parseGravTemplates(ctx, data){
                    let newTempFields = [];
                    let promises      = [];
               
                    data.templates.forEach((template) => {
                        let tAlias = template.match(/^[\\.\w]*=/)

                        if (tAlias[0]) {
                            tAlias   = ctx.state.pureVal(tAlias[0]).slice(0,-1) // "t.sponsor_info=" // => // "sponsor_info"
                            promises.push(ctx.state.parseTemplateValue(data.position, data.profile, template, ctx).then((newValue) => {
                                if (newValue) {
                                    newTempFields.push([tAlias, {
                                        title: newValue.replace(/^[\\.\w]*=/, '').replace(/{\B.*/, ''),
                                        value: {
                                            presentable : newValue.replace(/.*{\B/, '').replace(/[}{]/g,''),
                                            raw         : newValue,
                                        }
                                    }])
                                }
                            }))   
                        }
                    })

                    return Promise.all(promises).then(() => newTempFields)
                },
                getPropsLocalization(ctx) {
                    ctx.commit('setPropsLocalization', [
                        {
                            alias: 'account_id',
                            'en-US': 'Account ID',
                            'ru-RU': 'ID Аккаунта'
                        },{
                            alias: 'parent_name',
                            'en-US': 'Parent Name',
                            'ru-RU': 'Спонсор'
                        },{
                            alias: 'parent_id',
                            'en-US': 'Parent ID',
                            'ru-RU': 'ID спонсора'
                        },{
                            alias: 'title',
                            'en-US': 'Title',
                            'ru-RU': 'Название'
                        },{
                            alias: 'firstName',
                            'en-US': 'First Name',
                            'ru-RU': 'Имя'
                        },{
                            alias: 'firstname',
                            'en-US': 'First Name',
                            'ru-RU': 'Имя'
                        },{
                            alias: 'lastName',
                            'en-US': 'Last Name',
                            'ru-RU': 'Фамилия'
                        },{
                            alias: 'gender',
                            'en-US': 'Gender',
                            'ru-RU': 'Пол'
                        },{
                            alias: 'lastname',
                            'en-US': 'Last Name',
                            'ru-RU': 'Фамилия'
                        },{
                            alias: 'gender',
                            'en-US': 'Gender',
                            'ru-RU': 'Пол'
                        },{
                            alias: 'GV',
                            'en-US': 'Group Volume',
                            'ru-RU': 'Групповой объем'
                        },{
                            alias: 'NV',
                            'en-US': 'Network Volume',
                            'ru-RU': 'Сетевой объем'
                        },{
                            alias: 'ANV',
                            'en-US': 'Accumulated Network Volume',
                            'ru-RU': 'Накопленный сетевой объем'
                        },{
                            alias: 'SV',
                            'en-US': 'Side Volume',
                            'ru-RU': 'Боковой Volume'
                        },{
                            alias: 'CB',
                            'en-US': 'Cashback Bonus',
                            'ru-RU': 'Кэшбэк Бонус'
                        },{
                            alias: 'NB',
                            'en-US': 'Network Bonus',
                            'ru-RU': 'Сетевой Бонус'
                        },{
                            alias: 'IB',
                            'en-US': 'Instant Bonus',
                            'ru-RU': 'Мгновенный бонус'
                        },{
                            alias: 'LB',
                            'en-US': 'Leadership Bonus',
                            'ru-RU': 'Лидерский бонус'
                        },{
                            alias: 'Downline',
                            'en-US': 'Downline',
                            'ru-RU': 'Downline'
                        },{
                            alias: 'Skew',
                            'en-US': 'Skew',
                            'ru-RU': 'Скос'
                        },{
                            alias: 'Status',
                            'en-US': 'Status',
                            'ru-RU': 'Статус'
                        },{
                            alias: 'PV',
                            'en-US': 'Personal Volume',
                            'ru-RU': 'ЛО'
                        },{
                            alias: 'Purchases',
                            'en-US': 'Purchases',
                            'ru-RU': 'Покупки'
                        },{
                            alias: 'AR',
                            'en-US': 'Achieved Rank',
                            'ru-RU': 'Достигнутый ранг'
                        },{
                            alias: 'QR',
                            'en-US': 'Qualified Rank',
                            'ru-RU': 'В этом периоде выполнены условия квалификации'
                        },{
                            alias: 'Frontline',
                            'en-US': 'Frontline',
                            'ru-RU': 'Frontline'
                        },{
                            alias: 'Activity',
                            'en-US': 'Activity',
                            'ru-RU': 'Активность'
                        },{
                            alias: 'created_at',
                            'en-US': 'Created at',
                            'ru-RU': 'Дата регистрации'
                        },{
                            alias: 'Line1',
                            'en-US': 'Line 1 members',
                            'ru-RU': 'Line 1 members'
                        },{
                            alias: 'region_id',
                            'en-US': 'Region',
                            'ru-RU': 'Регион'
                        },{
                            alias: 'phone',
                            'en-US': 'Phone',
                            'ru-RU': 'Телефон'
                        },{
                            alias: 'email',
                            'en-US': 'E-mail',
                            'ru-RU': 'Почта'
                        },{
                            alias: 'country_id',
                            'en-US': 'Country',
                            'ru-RU': 'Страна'
                        },{
                            alias: 'birth_date',
                            'en-US': 'Birth date',
                            'ru-RU': 'Дата рождения'
                        },{
                            alias: 'sponsor_info',
                            'en-US': 'Sponsor info',
                            'ru-RU': 'Мой спонсор'
                        },{
                            alias: 'invite_code',
                            'en-US': 'Invite code',
                            'ru-RU': 'Реферальный код'
                        }
                    ]);
                },
                //pay in actions
                async pay({commit, dispatch}, {goodResponse, badResponse, amountW, subscription, documentCreate, amountPS, walletTypeId, paymentSystemId, changedPlanProperties, comment, callbackOk, orderData}) {
                    callbackOk = callbackOk || (x=>x);
                    const walletPay = amountW && !amountPS;
                    const badToast = (errMsg) => dispatch('showToast', {
                        title: 'Error',
                        body: errMsg || "Payment service is unavailable at the moment",
                        type: 'error'
                    });
                    //pay from wallet
                    if (walletPay){
                        const goodToast = () => dispatch('showToast', {
                            title: goodResponse.title ? goodResponse.title.replace('{sum}',amountW) : 'payment',
                            body: goodResponse.body ? goodResponse.body.replace('{sum}',amountW) : 'submitted',
                            type: 'success'
                        });
                        //check balance at walletTypeId
                        try {
                            await dispatch('requestApi3', {
                                path: 'account/' + (await dispatch('getAccountId') || -1) + '/wallet',
                                method: 'get'
                            }).then(async res => {
                                let wb = Array.isArray(res.data.payload) ? res.data.payload.find(wal => {
                                    return wal.id === walletTypeId
                                }) : null;
                                if (wb)
                                    wb = Number.parseFloat(wb['balance']);
                                else
                                    throw 'System can not find wallet';
                                if (amountW>wb)
                                    throw 'Not enough money in the wallet';

                                await dispatch('request',{
                                    path: 'api2/main-app/account/make-payment',
                                    method: 'post',
                                    params_: {
                                        "comment": comment,
                                        "documentAlias": documentCreate,
                                        "walletData": {
                                            "amount": amountW,
                                            "walletTypeId": walletTypeId
                                        },
                                        "fillUpData": {
                                            "amount": 0,
                                            "paymentSystemId": null
                                        },
                                        "accountId": await dispatch('getAccountId') || -1,
                                        "orderData": orderData || null,
                                        "changedPlanProperties": changedPlanProperties || {},
                                        "subscription": subscription || {},
                                    }
                                }).then((response)=>{
                                    if (response === 'loading'){
                                        badToast();
                                        return false;
                                    }
                                    if (!response.data.primary.success){
                                        badToast(response.data.errorMessage);
                                        return false;
                                    }
                                    goodToast();
                                    callbackOk();

                                    return true;
                                }).catch(e => {
                                    badToast(e.response && e.response.data ? e.response.data.errorMessage : null);
                                    return false;
                                })

                            })
                        }
                        catch (e) {
                            badToast(e);
                            return false;
                        }
                    } else
                    {
                        //pay from outside payment system
                        const checkPay = `f${(+new Date).toString(16)}`;
                        const processStartURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}?checkPay=${checkPay}`;//`https://dev-akorolikhin.onlineoffice.pro/?checkPay=${checkPay}`;
                        const returnParamUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?checkPay={{value1}}`;
                        await dispatch('request',{
                            path: 'api2/main-app/account/make-payment',
                            method: 'post',
                            params_: {
                                "comment": comment,
                                "documentAlias": documentCreate,
                                "fillUpData": {
                                    "amount": amountPS,
                                    "paymentSystemId": paymentSystemId||null
                                },
                                "walletData": {
                                    "amount": amountW||0,
                                    "walletTypeId": walletTypeId
                                },
                                "accountId": await dispatch('getAccountId') || -1,
                                "orderData": orderData || null,
                                "processStartURL": processStartURL,
                                "onSuccessReturnURL": {
                                    "template": returnParamUrl,
                                    "params": {
                                        "value1": "success"
                                    }
                                },
                                "onFailReturnURL": {
                                    "template": returnParamUrl,
                                    "params": {
                                        "value1": "fail"
                                    }
                                },
                                "subscription": subscription || {},
                                "changedPlanProperties": changedPlanProperties || {}
                            }
                        }).then((response)=>{
                            if (response === 'loading'){
                                badToast();
                                return false;
                            }
                            if (!response.data.primary.success){
                                badToast(response.data.errorMessage);
                                return false;
                            }
                            const {externalId, externalStatus, confirmationUrl} = response.data.primary.payload.fillUp;
                            const payment = {id: externalId, status: externalStatus, confirmationUrl};
                            payment.payId = checkPay;
                            payment.amount = amountPS;
                            payment.goodResponse = goodResponse;
                            payment.invoiceId = response.data.primary.payload.invoiceId;
                            payment.badResponse = badResponse;
                            commit('addPaymentToStack',payment);
                            callbackOk();
                            if (payment.confirmationUrl)
                                window.location.replace(payment.confirmationUrl);
                            else
                            {
                                const customParams = response.data.primary.payload.fillUp["customParams"];
                                //perfect money redirect and other payment systems that uses form forwarding
                                if (customParams){
                                        let f = document.createElement('form');
                                        f.action=customParams["FORM_ACTION"].toString().trim();
                                        f.method='POST';
                                        let p = document.createElement('p');
                                        f.appendChild(p);
                                        for (let [key,prop] of Object.entries(customParams)) {
                                            if (key.toString().trim() !== "FORM_ACTION")
                                            {
                                                let i=document.createElement('input');
                                                i.type='hidden';
                                                i.name=key;
                                                i.value=prop.toString().trim();
                                                p.appendChild(i);
                                            }
                                        }
                                        document.body.appendChild(f);
                                        f.submit();
                                }

                            }
                            dispatch('emptyCart');
                            return true;
                        }).catch(e => {
                            badToast(e.response && e.response.data ? e.response.data.errorMessage : null);
                            return false;
                        })
                    }

                },
                payResult({state, dispatch, commit},payId) {
                    if (state.paymentStack.length === 0)
                        return;
                    let payment = state.paymentStack.filter(x => x.payId===payId);
                    if (payment.length !== 1)
                        return;
                    payment = payment[0];
                    function gpb(forceNull = false){ dispatch('request',{
                        path: `api2/main-app/payment-system/get-invoice?id=${payment.invoiceId}`,
                        method: 'get'
                    }).then(response => {
                        if (response !== 'loading' && response.data.primary.success && response.data.primary.payload && response.data.primary.payload.invoice){
                            let indexOfPayment = -1;
                            payment = state.paymentStack.filter((x,i) => {let r =x.payId===payId; if (r) {indexOfPayment=i; return true} return false});
                            if (payment.length === 1)
                            {
                                payment = payment[0];
                                const removePayment = () => {
                                    if (indexOfPayment !== -1)
                                        commit('removePaymentFromStack',indexOfPayment);
                                };
                                switch (response.data.primary.payload.invoice.status) {
                                    case 'completed':
                                        dispatch('showToast', {
                                            title: payment.goodResponse.title ? payment.goodResponse.title.replace('{sum}',payment.amount) : 'payment',
                                            body: payment.goodResponse.body ? payment.goodResponse.body.replace('{sum}',payment.amount) : 'submitted',
                                            type: 'success'
                                        });
                                        removePayment();
                                        break;
                                    case 'processing':
                                        if (!forceNull)
                                            setTimeout(function(){gpb(true)},30000);
                                        else
                                            removePayment();
                                        break;
                                    default:
                                        dispatch('showToast', {
                                            title: payment.badResponse.title ? payment.badResponse.title.replace('{sum}',payment.amount) : 'payment',
                                            body: payment.badResponse.title ? payment.badResponse.body.replace('{sum}',payment.amount) : 'canceled',
                                            type: 'warning'
                                        });
                                        removePayment();
                                }

                            }

                        }
                    })}
                    setTimeout(gpb,5000);
                },
                emptyCart({ commit }) {
                    commit('emptyCart', [])
                    localStorage.removeItem('cart')
                },
                moveNewTokensToStorage({commit}) {
                    const ta = localStorage.getItem('user-single-a-token'),
                        tr = localStorage.getItem('user-single-r-token');
                    if (!ta || !tr) {
                        commit('setTokensToStorage', {
                            accessToken: null,
                            refreshToken: null
                        });
                    } else {
                        commit('setTokensToStorage', {
                            accessToken: ta,
                            refreshToken: tr
                        });
                        commit('setIsLoggedIn', true);
                    }
                    commit('setSingleTokensToStorage', {
                        singleAccessToken: null,
                        singleRefreshToken: null
                    });
                },
                async axios({state}, {path, method}) {
                    

                    return ProxyService.getFromAxios(state, {
                        path: path,
                        method: method,
                        params_: {}
                    })

                },
                async getAccountId({state, dispatch, commit}) {
                    if (state.accountId)
                        return state.accountId;

                    let HTTP = state.loadingAccountId || dispatch('requestApi3', {
                        path: `account/current`,
                        method: 'get'
                    })

                    if (!state.loadingAccountId)
                        commit('setLoadingAccountId', HTTP);

                    await HTTP.then(res => {
                        let cId = res?.data?.payload?.id;
                        if (cId != undefined) {
                            state.accountId = res?.data?.payload?.id;
                            commit('setCurrentAccount', res.data.payload);
                        }
                    }).catch((e) => {
                        console.log(e)
                        state.accountId = null;
                    })

                    await dispatch('requestApi3', {
                        path: `account/${state.accountId}/profile`,
                        method: 'get'
                    }).then(res => {
                        state.CURRENTPROFILE = res.data?.payload || [];
                        commit('setCurrentProfile', res.data?.payload);
                    }).catch((e) => {
                        console.log(e)
                        state.currentProfile = null;
                    })

                    return Number(state.accountId);
                },
                // async getAccountId2({state, dispatch}) {
                //     if (state.accountId)
                //         return state.accountId;
                //     let HTTP = dispatch('requestApi3', {
                //         path: `account/current`,
                //         method: 'get'
                //     });

                //     await HTTP.then(res => {
                //         let cId = res?.data?.payload?.id;
                //         if (cId != undefined) {
                //             state.accountId = res?.data?.payload?.id;
                //         }
                //     }).catch((e) => {
                //         console.log(e)
                //         state.accountId = null;
                //     })
                //     return state.accountId;
                // },
                async hasAccountPosition({state, dispatch}) {
                    if (state.accountId) {
                        await dispatch('requestApi3', {
                            path: `account/${state.accountId}/position`,
                            method: 'get'
                        }).then(response => {
                          console.log(response)
                        }).catch((e) => {
                          console.log(e)
                          let errElement = document.getElementById('noPositionMessage')
                          errElement.style.display = 'block'
                        })
                    } else {
                        return false
                    }
                },
                showToast({state}, {title, body, type, timeout}) {
                    state.toastFunction(title, body, type, timeout);
                },
                async getAccountInfo({commit, state, dispatch}, {ids, properties}) {
                    try {
                        //exit if something wrong
                        if (!ids || !properties || !(Array.isArray(ids)) || !(Array.isArray(properties)) || (ids.length === 0) || (properties.length === 0))
                            return null;
                        //else if okey-> define variables
                        let new_ids = [], new_properties = new Set(), loading_account_info = new Set();
                        let retMap = new Map();
                        //list of account info values
                        let _properties = new Set(properties);
                        properties.filter(id => id[0] === 't').forEach(item => {
                            if (state.accountTemplate.has(item) && state.accountTemplate.get(item).obj_set.size)
                                state.accountTemplate.get(item).obj_set.forEach(itemInner => _properties.add(itemInner));
                        });
                        properties = [..._properties];
                        ids.forEach(item => {
                            let flag = false;
                            properties.filter(id => id[0] !== 't').forEach(itemInner => {
                                const key = item + '.' + itemInner;
                                retMap.set(key, null);
                                let value = mcache.get(key);
                                if ((!value || !state.accountInfo.has(key)) && !state.loadingAccountInfo.has(key)) {
                                    flag = true;
                                    new_properties.add(itemInner);
                                    loading_account_info.add(key);
                                }
                            });
                            if (flag)
                                new_ids.push(item);
                        });
                        new_properties = [...new_properties];
                        if (new_ids.length && new_properties.length) {
                            let str1 = '', str2 = '';
                            new_ids.forEach(value => {
                                str1 += '&ids[]=' + value;
                            });
                            str1 = '?' + str1.substr(1);
                            new_properties.forEach(value => {
                                str2 += '&properties[]=' + value;
                            });
                            const HTTP = dispatch('request', {
                                path: 'api2/main-app/account/get-info' + str1 + str2,
                                method: 'get'
                            });
                            if (HTTP instanceof Promise) {
                                loading_account_info.size && commit('setLoadingAccountInfo', {
                                    newSet: [...loading_account_info],
                                    newPromise: HTTP
                                });
                                await HTTP.then(response => {
                                    if (response.data.errorCode === 0) {
                                        let v = new Map(), v_map = new Map();
                                        let map = response['data']['primary']['payload']['map'];
                                        for (let prop in map) {
                                            if (Object.prototype.hasOwnProperty.call(map, prop) && !Array.isArray(map[prop])) {
                                                for (let prop_inner in map[prop]) {
                                                    if (Object.prototype.hasOwnProperty.call(map[prop], prop_inner)) {
                                                        let key_map = prop + prop_inner;
                                                        if (!state.mapAccountInfo.has(key_map))
                                                            v_map.set(key_map, map[prop][prop_inner]);
                                                    }
                                                }
                                            }
                                        }
                                        v_map.size && commit('setMapAccountInfo', [...v_map]);
                                        map = response['data']['primary']['payload']['list'];
                                        loading_account_info = [];
                                        for (let prop in map) {
                                            let key_map;
                                            if (Object.prototype.hasOwnProperty.call(map, prop)) {
                                                for (let prop_inner in map[prop]) {
                                                    if (Object.prototype.hasOwnProperty.call(map[prop], prop_inner) && !Array.isArray(map[prop][prop_inner])) {
                                                        for (let prop_inner2 in map[prop][prop_inner]) {
                                                            if (Object.prototype.hasOwnProperty.call(map[prop][prop_inner], prop_inner2)) {
                                                                key_map = prop + '.' + prop_inner + prop_inner2;
                                                                v.set(key_map, map[prop][prop_inner][prop_inner2]);
                                                                loading_account_info.push(key_map);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        v.size && commit('setAccountInfo', [...v]);
                                        loading_account_info.length && commit('deleteLoadingAccountInfo', loading_account_info);
                                    }
                                }).catch(() => {
                                    loading_account_info.size && commit('deleteLoadingAccountInfo', [...loading_account_info]);
                                    return new Map();
                                });
                            }
                        }
                        let retPromise = new Set();
                        retMap.forEach((value, key) => {
                            state.loadingAccountInfo.has(key) && retPromise.add(state.loadingAccountInfo.get(key));
                        });
                        for (let i = 0, arrR = [...retPromise]; arrR.length > i; i++) {
                            await arrR[i];
                        }
                        let newTemplateAccount = new Map();
                        ids.forEach(item => {
                            let flag = false;
                            properties.filter(id => id[0] === 't').forEach(itemInner => {
                                const key = item + '.' + itemInner;
                                retMap.set(key, null);
                                newTemplateAccount.set(key, {presentableValue: state.accountTemplate.get(itemInner).obj_func(item)});
                            });
                            if (flag)
                                new_ids.push(item);
                        });
                        commit('setAccountInfo', [...newTemplateAccount]);
                        retMap.forEach(((value, key) => {
                            retMap.set(key, state.accountInfo.get(key));
                        }));
                        return retMap;
                    } catch (e) {
                        return e;
                    }

                },
                //gets localization for your component, module =  component name(name of translation in proxy dir)
                async getLocalizationModule({state}, {module, i18n, customLocalization, UIProxyLoc}) {
                    let isGlobal = /core.txt/.test(customLocalization) // use store instead as param!

                    await LocalizationService.getLocalization(module, customLocalization).then(
                        (response) => {

                            for (let key in UIProxyLoc) {
                                for (let key2 in UIProxyLoc[key]['message']) {
                                    response[0].data[key]['message'][key2] = UIProxyLoc[key]['message'][key2]
                                }
                            }

                            if (Array.isArray(response))
                                response = merge(...response)
                            for (let key in response.data) {
                                if (Object.prototype.hasOwnProperty.call(response.data, key)) {
                                    i18n.setLocaleMessage(key, response.data[key]);
                                }
                            }
                            i18n.locale = state.locale;
                        }
                    ).catch(reason => {
                        if (isGlobal) {
                            return reason;
                        }

                        toastDebounce('System Warning',
                            'Sorry, the service is temporarily unavailable, please try later',
                            'warning'
                        );
                        throw reason;
                    });
                },
                logout({commit}) {
                    localStorage.removeItem('user-token');
                    localStorage.removeItem('user-refresh-token');
                    localStorage.removeItem('accessTokenApi3');
                    localStorage.removeItem('refreshTokenApi3');
                    localStorage.removeItem('cart');
                    // commit('setIsLoggedIn', false);
                    // commit('setIsLoggedInApi3', false);
                    commit('resetState');
                    document.cookie = 'tkns'+'="";-1; path=/';
                    localStorage.setItem('logout', '1');

                    if(
                        window.location.host === 'dev-suzuverse-test.onlineoffice.pro' ||
                        window.location.host === 'suzuverse.onlineoffice.pro' ||
                        window.location.host === 'affiliate.suzuverse.com'
                    ) {
                        window.location.replace('https://ams.suzuverse.com');
                    } else {
                        window.location.reload('/login');
                    }
                    
                },
                login({commit, state}, {m, p}) {
                    return AuthService.loginProxy(state, {m, p}).then(response => {

                        if (response == 'Server is not available') {
                            throw response
                        }

                        commit('setTokensToStorage', {
                            accessToken: response.data.access_token,
                            refreshToken: response.data.refresh_token
                        });
                        commit('setIsLoggedIn', true);
                        commit('setApi3TokensToStorage', {
                            accessToken: localStorage.getItem('accessTokenApi3'),
                            refreshToken: localStorage.getItem('refreshTokenApi3')
                        });
                        commit('setIsLoggedInApi3', true);
                        return 'ok';
                    }).catch((e) => {
                        return e;
                    })
                },
                loginAfter({commit, state}, {m, p, t}) {
                    return AuthService.loginProxyAfter(state, {m, p, t}).then(response => {

                        commit('setTokensToStorage', {
                            accessToken: response.data.access_token,
                            refreshToken: response.data.refresh_token
                        });
                        commit('setIsLoggedIn', true);
                        return 'ok';
                    }).catch((e) => {

                        return e;
                    })
                },
                loginCode({commit, state}, {c}) {
                    return AuthService.loginProxyFromMail(state,{c}).then(response => {
                        commit('setSingleTokensToStorage', {
                            singleAccessToken: response.data.access_token,
                            singleRefreshToken: response.data.refresh_token
                        });
                        return 'ok';
                    }).catch((e) => {
                        return e;
                    })
                },
                login_() {
                    return 'loading';
                },
                reqApi({state}, {path, method, params_, headers, onDownloadProgress}) {
                    if (['get', 'post', 'put', 'delete'].indexOf(method) === -1)
                        throw 'error handling method: ' + method;
                    return ProxyService.getFromApi3Unauth(state, {
                        path: path,
                        method: method,
                        params_: params_ || {},
                        headers: headers,
                        onDownloadProgress: onDownloadProgress || function() {}
                    }).then(response => {
                        return response;
                    }).catch((e) => {
                        return e?.response?.data;
                    });
                },
                requestApi3({dispatch, commit, state}, {path, method, params_, headers, onDownloadProgress}) {
                    commit('getApi3TokensFromStorage');

                    // just for some case, if api3 tokens will not be found, we will remove ui-tokens too
                    if((!state.accessTokenApi3 || !state.refreshTokenApi3) && (localStorage.getItem('user-token') && localStorage.getItem('user-refresh-token'))) {
                        localStorage.removeItem('user-token');
                        localStorage.removeItem('user-refresh-token');
                        window.location.reload('/login');
                    }
                    // ----------------------------------------------------------------------------------
                    
                    if (['get', 'post', 'put', 'delete'].indexOf(method) === -1)
                        throw 'error handling method: ' + method;

                    return ProxyService.getFromApi3(state, {
                        path: path,
                        method: method,
                        params_: params_ || {},
                        headers: headers || {},
                        onDownloadProgress: onDownloadProgress || function() {}
                    }).then(response => {
                        return response;
                    }).catch((e) => {
                        console.log(e.response?.data)
                        if (state.refreshTokenApi3) {
                            // if(e.response.data.error.description === 'Unauthorized')
                            if (state.refreshTokenAction == null)
                                commit('setRefreshApi3TokenAction', AuthService.refreshTokenApi3(state));
                            try {
                                return state.refreshTokenActionApi3.then(re => {
                                    state.accessTokenApi3 = re.data.payload.accessToken;
                                    state.refreshTokenApi3 = re.data.payload.refreshToken;
                                    window.localStorage.setItem('accessTokenApi3', re.data.payload.accessToken);
                                    window.localStorage.setItem('refreshTokenApi3', re.data.payload.refreshToken);
                                    state.refreshTokenActionApi3 = null;
                                    return ProxyService.getFromApi3(state, {
                                        path: path,
                                        method: method,
                                        params_: params_ || {},
                                        onDownloadProgress: onDownloadProgress || function() {}
                                    }).then(response => {
                                        return response;
                                    }).catch((er) => {
                                        if (er !== '500') {
                                            console.log('er_', er);
                                            return er
                                        }
                                        // commit('setApi3TokensToStorage', {accessToken: null, refreshToken: null});
                                        // commit('setIsLoggedIn', false);
                                        // commit('setIsLoggedInApi3', false);
                                        // return dispatch('login_');
                                    })
                                }).catch((err) => {
                                    if (err == 500){
                                        commit('setApi3TokensToStorage', {accessToken: null, refreshToken: null});
                                        commit('setTokensToStorage', {accessToken: null, refreshToken: null});
                                        commit('setIsLoggedIn', false);
                                        commit('setIsLoggedInApi3', false);
                                        
                                        window.location.reload();
                                        return dispatch('login_');
                                    } else if (err.error == undefined) {
                                        throw 400
                                    } else {
                                        console.log(err)
                                    }
                                });
                            } catch(errr){
                                if (errr !== '500')
                                    throw errr;
                                commit('setApi3TokensToStorage', {accessToken: null, refreshToken: null});
                                commit('setIsLoggedIn', false);
                                commit('setIsLoggedInApi3', false);
                                state.refreshTokenActionApi3 = null;
                                return dispatch('login_');
                            }
                        } else {
                            commit('setApi3TokensToStorage', {accessToken: null, refreshToken: null});
                            commit('setIsLoggedIn', false);
                            commit('setIsLoggedInApi3', false);
                            commit('resetState');
                            return dispatch('login_');
                        }
                    });
                },
                request({dispatch, commit, state}, {path, method, params_, withoutCheckLogin, token, onDownloadProgress}) {
                    commit('getTokensFromStorage');
                    if (!state.isLoggedIn && !withoutCheckLogin)
                        return dispatch('login_');
                    if (['get', 'post', 'put', 'delete'].indexOf(method) === -1)
                        throw 'error handling method: ' + method;
                    return ProxyService.getFromProxy(state, {
                        path: path,
                        method: method,
                        params_: params_ || {},
                        token: state.accessToken || token,
                        onDownloadProgress: onDownloadProgress || function() {}
                    }).then(response => {
                        return response;
                    }).catch((e) => {
                        if (e !== '500') {
                            if ((e.response && (e.response.status === 404)) || (e.response == null))
                                toastDebounce('System Warning',
                                    'Sorry, the service is temporarily unavailable, please try later',
                                    'warning'
                                );
                            throw e;
                        }
                        if (state.refreshToken) {
                            if (state.refreshTokenAction == null)
                                commit('setRefreshTokenAction', AuthService.refreshToken(state));
                            return state.refreshTokenAction.then(response => {
                                commit('setTokensToStorage', {
                                    accessToken: response.data.access_token,
                                    refreshToken: response.data.refresh_token
                                });
                                state.refreshTokenAction = null;
                                return ProxyService.getFromProxy(state, {
                                    path: path,
                                    method: method,
                                    params_: params_ || {},
                                    onDownloadProgress: onDownloadProgress || function() {}
                                }).then(response => {
                                    return response;

                                }).catch((er) => {
                                    if (er !== '500')
                                        throw er;
                                    commit('setTokensToStorage', {accessToken: null, refreshToken: null});
                                    commit('setIsLoggedIn', false);
                                    commit('setIsLoggedInApi3', false);
                                    commit('resetState');
                                    window.location.reload();
                                    return dispatch('login_');
                                })
                            }).catch((errr) => {
                                if (errr !== '500')
                                    throw errr;
                                commit('setTokensToStorage', {accessToken: null, refreshToken: null});
                                commit('setIsLoggedIn', false);
                                commit('setIsLoggedInApi3', false);
                                commit('resetState');
                                state.refreshTokenAction = null;
                                window.location.reload();
                                return dispatch('login_');

                            });
                        } else {
                            if(localStorage.getItem('user-token') && localStorage.getItem('user-refresh-token')) {
                                commit('setTokensToStorage', {accessToken: localStorage.getItem('user-token'), refreshToken: localStorage.getItem('user-refresh-token')});
                            } else {
                                commit('setTokensToStorage', {accessToken: null, refreshToken: null});
                                commit('setIsLoggedIn', false);
                                commit('setIsLoggedInApi3', false);
                                commit('resetState');
                            }
                            window.location.reload();
                            return dispatch('login_');
                        }
                    });
                },
                requestFromNewAccount({commit, state}, {path, method, params_}) {
                    commit('getSingleTokensFromStorage');
                    if (['get', 'post', 'put', 'delete'].indexOf(method) === -1)
                        throw 'error handling method: ' + method;
                    return ProxyService.getFromProxy(state, {
                        path: path,
                        method: method,
                        params_: params_ || {},
                        isNewAccount: true,
                        onDownloadProgress: function () {}
                    }).then(response => {
                        return response;
                    }).catch((e) => {
                        if (e !== '500')
                            throw e;
                        commit('setSingleTokensToStorage', {singleAccessToken: null, singleRefreshToken: null});
                    });
                },
                //feed
                setFeedUrl({state,commit}, newFeedUrl) {
                    const fu = localStorage.getItem('feedUrl') || '';
                    commit('setFeedUrl', fu);
                    if (state.feedUrl !== newFeedUrl){
                        localStorage.setItem('feedUrl', newFeedUrl);
                        commit('setFeedUrl', newFeedUrl);
                    }
                },
                updateCartFromStorage({commit}) {
                    commit('updateCartFromStorage');
                },
                updateCart({commit}) {
                    commit('updateCart');
                },
                setFeedProductCount({commit}, product){
                    commit('setFeedProductCount', product);
                },
                async getFeedRemote({state, commit}, paramsObject) {
                    let remoteUrl = paramsObject.url;
                    if(paramsObject.categories) {
                        if(remoteUrl.indexOf('?') === -1) {
                            remoteUrl += '?catalogid='+paramsObject.categories;
                        } else {
                            remoteUrl += '&catalogid='+paramsObject.categories;
                        }
                    }
                    let typeOfFeed = localStorage.getItem('feedType');
                    if(typeOfFeed === 'local') {
                        localStorage.setItem('feed', '');
                        localStorage.setItem('feedType', 'global');
                    }
                    if(!typeOfFeed) {
                        localStorage.setItem('feedType', 'global');
                    }
                    let productItems = []
                        try {
                            await fetch(remoteUrl).then(response => response.json()).then(data => {

                                if (data.success === true) {
                                    if (paramsObject.isV2) {
                                        let items          = data.payload.list == undefined ? [data.payload] : data.payload.list;
                                        data.payload.items = [];

                                        items.forEach((item) => {
                                            let category             = item.itemCategories[item.itemCategories.length - 1];
                                            let obj                  = {};

                                            obj['g:id']              = item.id
                                            obj['g:product_type']    = category?.title || 'Unknown'
                                            obj['description']       = item.description
                                            obj['g:availability']    = null
                                            obj['g:image_link']      = item.imageUrl
                                            obj['g:price']           = item.itemPrices[0].price
                                            obj['g:pv']              = item.itemVolumes[0].value
                                            obj['g:quantity']        = null
                                            obj['title']             = item.title
                                            obj['volume_properties'] = { pv: item.itemVolumes[0].value }

                                            data.payload.items.push(obj)
                                        })
                                    }

                                    data.payload.items.forEach(a => {
                                        a.count = 0;
                                        let a_ = a["g:product_type"].split(">");
                                        if (a_.length <= state.feedGroupNumber)
                                            a["g:product_type"] = a_[a_.length - 1].trim();
                                        else
                                            a["g:product_type"] = a_[state.feedGroupNumber].trim();
                                    });
                                    if (!state.feed.feedInner) {
                                        productItems = [...data.payload.items];
                                        let cartArrString = localStorage.getItem('cart') || '';
                                        let cartArr = cartArrString !== '' ? JSON.parse(cartArrString) : []

                                        cartArr.map((item) => {
                                            data.payload.items.map((pItem, pkey) => {
                                                if (item["g:id"] == pItem["g:id"]) {
                                                    productItems[pkey]["count"] = item["count"]
                                                }
                                            })
                                        });

                                        productItems.map(i => {
                                            if(i.volume_properties !== undefined) {
                                                for (const [key, value] of Object.entries(i.volume_properties)) {
                                                    i['g:' + key] = value
                                                }
                                            }
                                        })
                                        commit('setFeed', {feedInner: {items: productItems}});
                                        localStorage.setItem('feed', JSON.stringify({feedInner: {items: productItems}}));
                                    } else {
                                        productItems = state.feed.feedInner.items
                                    }
                                }
                            })
                        } catch (e) {
                            commit('deleteFeed')
                        }
                    return {feedInner: {items: [...productItems]}};
                },
                async getFeed({state, commit}, marketingParams) {
                    let typeOfFeed = localStorage.getItem('feedType');
                    if(!typeOfFeed || typeOfFeed === 'global') {
                        localStorage.setItem('feed', '');
                        localStorage.setItem('feedType', 'local');
                    }

                    const mp = ([...marketingParams.keys()].map(a=>'g:'+a.toLowerCase()));
                    //check if actual in vuex
                    const today = new Date();
                    if (state.feed.feedInner && today <= state.feed.feedInner.expiresDate)
                        return state.feed;
                    //check if exists in localStorage
                    let feedFromLocale = localStorage.getItem('feed');
                    if (feedFromLocale) {
                        try {
                            feedFromLocale = JSON.parse(feedFromLocale);
                        }
                        catch (e) {
                            feedFromLocale = null;
                        }
                    }
                    let temp = {}
                        try {
                            const data = await fetch(state.feedUrl);
                            if (data.ok) {
                                const text = await data.text();
                                const parser = new RSSParser({
                                    customFields: {
                                        item: ['g:price','g:image_link','g:id','g:title','g:description','g:product_type','g:availability'].concat(mp)
                                    }
                                });
                                await parser.parseString(text).then(parsed=>{
                                    parsed.expiresDate = new Date(Date.now() + 24*60*60*1000).toISOString();
                                    parsed.items.forEach(a => {
                                        a.count = 0;
                                        let a_ = a["g:product_type"].split(">");
                                        if (a_.length <= state.feedGroupNumber)
                                            a["g:product_type"] = a_[a_.length - 1].trim();
                                        else
                                            a["g:product_type"] = a_[state.feedGroupNumber].trim();
                                    });
                                    temp = parsed.items
                                    localStorage.setItem('feed', JSON.stringify({feedInner: {items: parsed.items}}));
                                    localStorage.setItem('feedLocale', state.locale);
                                    commit('setFeed',{feedInner: {items: parsed.items}});
                                }).catch(() => commit('deleteFeed'));
                            } else {
                                //"Error occured while fetching the feed";
                                commit('deleteFeed');
                            }
                        } catch (e) {
                            commit('deleteFeed');
                        }
                    commit('setFeed',{feedInner: {items: temp}});
                    return {feedInner: {items: temp}};
                },
                async sendCheckPhone({state}, phone) {
                    let res = '';
                    await fetch(`https://${window.location.host}/api3/otp/sms`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                            phone: phone.replace(/\s/g, ''),
                            language: state.locale
                        })
                    }).then(j => j.json()).then(r => {
                        if(r.success === true ) {
                            state.phoneReqId = r.payload.requestId
                            res = {'result': 'ok', 'requestId': r.payload.requestId }
                        } else {
                            if(r.error?.data?.timeLeft !== undefined) {
                                res = {'result': 'error', 'error': r.error?.description, 'time': r.error?.data?.timeLeft, 'time_descr': r.error?.description }
                            } else {
                                res = {'result': 'error', 'error': r.error?.details[0].msg || r.error }
                            }
                        }
                    }).catch(e => {
                        res = e
                    });
                    return res;
                },
                async sendCheckPhoneCode({state}, code) {
                    let result = '';
                    await fetch(`https://${window.location.host}/api3/otp/check`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                            otp_type: 'phone_confirm',
                            requestId: state.phoneReqId,
                            code: code
                        })
                    }).then(j => j.json()).then(r => {
                        if(r.success === true) {
                            result = r.payload.verified === true ? 'ok' : 'wrong';
                        } else {
                            result = r.error?.details[0].msg || r.error
                        }
                    }).catch(
                        (e) => {
                            console.log(e)
                        }
                    );
                    return result;
                },
                async checkExistsEmail({state}, email) {
                    console.log(state?.accountId)

                    return await fetch(`https://${window.location.host}/api3/account/check-exists`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                            email: email
                        })
                    }).then(j => j.json()).then(r => {
                        return r;
                    });
                },
                async sendCheckEmail({state}, email) {
                    let res = '';
                    await fetch(`https://${window.location.host}/api3/otp/email`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                            email: email,
                            language: state.locale
                        })
                    }).then(j => j.json()).then(r => {
                        if(r.success === true ) {
                            state.emailReqId = r.payload.requestId
                            res = {'result': 'ok', 'requestId': r.payload.requestId }
                        } else {
                            if(r.error?.data?.timeLeft !== undefined) {
                                res = {'result': 'error', 'error': r.error?.description, 'time': r.error?.data?.timeLeft, 'time_descr': r.error?.description }
                            } else {
                                res = {'result': 'error', 'error': r.error?.details[0].msg || r.error }
                            }
                        }
                    });
                    return res;
                },
                async sendCheckEmailCode({state}, code) {
                    let result = '';
                    await fetch(`https://${window.location.host}/api3/otp/check`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8'
                        },
                        body: JSON.stringify({
                            otp_type: 'email_confirm',
                            requestId: state.emailReqId,
                            code: code
                        })
                    }).then(j => j.json()).then(r => {
                        if(r.success === true) {
                            result = r.payload.verified === true ? 'ok' : 'wrong';
                        } else {
                            result = r.error?.details[0].msg || r.error
                        }
                    }).catch(
                        (e) => {
                            console.log(e)
                        }
                    );
                    return result;
                },

                writeOtpCheck({state}, otpCheck) {
                    state.otpCheck = otpCheck
                },
                async changePassword({state}, {email, phone, password}) {
                    let result = '';
                    await fetch(`https://${window.location.host}/api3/account/set-password`, {
                        method: 'post',
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                            'x-otp-check' : state.otpCheck
                        },
                        body: JSON.stringify({
                            password: password,
                            email: email,
                            phone: phone?.replace(/\s/g, '') || ''
                        })
                    }).then(j => j.json()).then(r => {
                        if(r.success === true) {
                            result = 'ok';
                        } else {
                            result = r.error?.details[0].msg || r.error
                        }
                    }).catch(
                        (e) => {
                            console.log(e)
                        }
                    );
                    return result;
                },
                getHeaderCartCoords({ commit }, { x, y }) {
                    commit('setHeaderCartCoords', { x, y });
                },
                setOnlineStatus({ commit }, status) {
                    commit('setOnlineStatus', status);
                }
            }
        });

        this.#store.commit('setEmptyPerson', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/empty_person/avatar_undefined.png'}`);
        this.#store.commit('setLazyLoadItem', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/lazy_load/load_item.svg'}`);
        this.#store.commit('setEmptyPersonMale', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/empty_person/avatar_male.png'}`);
        this.#store.commit('setEmptyPersonFemale', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/empty_person/avatar_female.png'}`);
        this.#store.commit('setLoginBackImg', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/background/blurred-bg-3.jpg'}`);
        this.#store.commit('setAvatarAddNew', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/binary_view/avatar_add_new.png'}`);
        this.#store.commit('setAvatarLock', `${proxyConfig.ip_proxy + ':' + proxyConfig.port_proxy + '/' + proxyConfig.subPath + 'static/img/binary_view/avatar_lock.png'}`);
    }

    getStore() {
        return this.#store;
    }

    static get instance() {
        if (!this[sUIApi2])
            this[sUIApi2] = new MLMSoftUICore(sUIApi2Enforcer);
        return this[sUIApi2];
    }

    static set instance(v) {
        throw "Can't change constant property to " + v;
    }

    //input mask methods
    static wearMaskMoney(str) {
        function separateByThousandths(str, delimiter) {
            return str.replace(/\B(?=(\d{3})+(?!\d))/g, `${delimiter}`);
        }

        function decimalize(numstr) {
            if (numstr.length > 1) {
                let dp = numstr.substring(numstr.length - 2, numstr.length);
                let denom = numstr.substring(0, numstr.length - 2);
                if (denom.substring(0, 1) === "0") {
                    denom = denom.substring(1, denom.length);
                }
                denom = denom || '0';
                return `${denom}.${dp}`;
            }
            if (numstr.length === 1)
                return `0.0${numstr}`;
            return `0.00`;
        }

        let num = decimalize(str);
        num = separateByThousandths(num, thousandDelimeter);
        return num;
    }

    static removeMaskMoney(numstr) {
        let num = parseInt(numstr.replace(/\D+/g, ""));
        return Number.isInteger(num) ? num.toString() : numstr.replace(/\D+/g, "");
    }

    static processInputFloat(e) {
        let pressedKey = e.which,
            point = e.target.value.indexOf("."),
            keys = keyCodes.windows;

        // HACK for Chrome on Android (doesn't seem to work, though)
        if (pressedKey === keys["input busy"]) {
            e.preventDefault();
            return;
        }

        let allowedKeys = [
            keys["backspace"],
            keys["tab"],
            keys["enter"],
            keys["left arrow"],
            keys["right arrow"],
            keys["delete"],
            keys["period"],
            keys["num period"]
        ];

        // Decimal point already in value
        if (point !== -1) {
            allowedKeys.splice(allowedKeys.indexOf(keys["period"]), 1);
            allowedKeys.splice(allowedKeys.indexOf(keys["num period"]), 1);

            if (e.target.value.length > (point + 8) && this.selectionStart === this.selectionEnd &&
                (!allowedKeys.includes(pressedKey))) {
                // Allow only 2 decimal places, allow whitelisted keys after 2 decimal places reached
                e.preventDefault();
                return;
            }
        }

        if ((pressedKey < keys["0"] || pressedKey > keys["9"]) &&
            (pressedKey < keys["num 0"] || pressedKey > keys["num 9"]) &&
            (!allowedKeys.includes(pressedKey))) {
            // Allow only whitelisted (non-numeric) keys
            e.preventDefault();
        }
    }

    static setThousandDelimeter(delm) {
        thousandDelimeter = delm;
    }

    static getThousandDelimeter() {
        return thousandDelimeter;
    }

    static setAccountMask(val) {
        accountMask = val;
    }

    static getAccountMask() {
        return accountMask;
    }

    static formatAccountId(s) {
        if(accountMask === '0'){
            return s
        } else {
            let s_ = [...accountMask];
            let s_Length = s_.length - 1;
            [...s].reverse().forEach((item) => {
                // eslint-disable-next-line no-constant-condition
                while (s_Length > -1 && (s_[s_Length] !== '0' || ((s_[s_Length] = item) && (s_Length = s_Length - 1) && false))) s_Length = s_Length - 1;
            });
            return s_.join("")
        }
    }

    static processInputInt(e) {
        let pressedKey = e.which,
            keys = keyCodes.windows;

        // HACK for Chrome on Android (doesn't seem to work, though)
        if (pressedKey === keys["input busy"]) {
            e.preventDefault();
            return;
        }

        let allowedKeys = [
            keys["backspace"],
            keys["tab"],
            keys["enter"],
            keys["left arrow"],
            keys["right arrow"],
            keys["delete"],
            keys["period"],
            keys["num period"]
        ];

        // Decimal point already in value

        allowedKeys.splice(allowedKeys.indexOf(keys["period"]), 1);
        allowedKeys.splice(allowedKeys.indexOf(keys["num period"]), 1);

        if (e.target.value.length > 20 && this.selectionStart === this.selectionEnd &&
            (!allowedKeys.includes(pressedKey))) {
            // Allow only 2 decimal places, allow whitelisted keys after 2 decimal places reached
            e.preventDefault();
            return;
        }


        if ((pressedKey < keys["0"] || pressedKey > keys["9"]) &&
            (pressedKey < keys["num 0"] || pressedKey > keys["num 9"]) &&
            (!allowedKeys.includes(pressedKey))) {
            // Allow only whitelisted (non-numeric) keys
            e.preventDefault();
        }
    }


}
